<template>
  <div id="footer">
    <div class="container-fluid">
      <div class="left">
        <div class="logo">
          <img src="@/assets/img/logo.png" alt="logo图" />
          <span style="margin-left: 20px;">胜源纸品</span>
        </div>
        <div class="box">
          <h2>艰苦奋斗 诚信敬业 守护好每一件商品</h2>
          <span
            >WORK HARD, BE HONEST AND DEDICATED, AND PROTECT EVERY PRODUCT</span
          >
        </div>
      </div>
      <div class="right">
        <div class="line"></div>
        <p class="address_tel_fax">
          <span>网站地址：http://www.dgsyzp.com</span>
          <span>地址：东莞市望牛墩镇朱平沙村桥围路1号</span>
          <span
            >电话：
            <p style="color: #FFB200;">0769-81318206</p></span
          >
          <span>邮箱：414156044@qq.com</span>
        </p>
        <div class="QRcode">
          <img src="@/assets/img/QRcode.png" alt="二维码" />
        </div>
      </div>
    </div>
    <div
      class="beian-container"
      style="width: 100%; font-size: 16px; text-align: center; padding: 10px 0; color: #a8a8a8;  "
    >
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="font-size: 16px; color: #a8a8a8; text-decoration: none;"
      >
        粤ICP备2021120863号-3
      </a>
      | Copyright © 2026 胜源集团 版权所有
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
#footer {
  width: 100%;
  height: 100%;
  padding: 20px 0 35px;
  color: #fff;
  background: #474747;
  overflow: hidden;
  /* text-align: center; */
}
.container-fluid {
  position: relative;
  width: 100%;
  padding: 4vh 6vw;
  display: flex;
  margin: 0;
  .left {
    width: 60%;
  }
  .right {
    position: relative;
    width: 40%;
    display: flex;
    margin-top: 4vh;
    .line {
      position: absolute;
      top: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(90deg, #56b9ff 0%, #005eaf 100%);
      border-radius: 4px;
    }
  }
}
.logo {
  height: 80px;
  display: flex;
  align-items: center;
}
.logo img {
  width: 58px;
  height: 58px;
}
.logo span {
  width: 132px;
  height: 46px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 33px;
  color: #ffb200;
  line-height: 46px;
  text-align: left;
  font-style: normal;
}
.box {
  h2 {
    font-family: Fontquan-XinYiGuanHeiTi, Fontquan-XinYiGuanHeiTi;
    font-weight: 400;
    font-size: 24px;
    color: #ffb200;
    line-height: 34px;
    letter-spacing: 8px;
    text-align: left;
    font-style: normal;
  }
  span {
    display: block;
    width: 28vw;
    font-family: Arial, Arial;
    font-weight: 900;
    font-size: 18px;
    color: #ffffff;
    line-height: 33px;
    text-align: left;
    font-style: normal;
  }
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  display: flex;
  flex-direction: column;
  margin-top: 4vh;
  p {
    display: inline-block;
  }
}
.address_tel_fax span {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #a8a8a8;
  line-height: 38px;
  letter-spacing: 1px;
  text-align: left;
  font-style: normal;
}
.QRcode {
  margin-left: 3.125vw;
  margin-top: 4vh;
}
.QRcode img {
  width: 160px;
  height: 160px;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue